import { render } from "./ImageWatermark.vue?vue&type=template&id=49bd2861&scoped=true"
import script from "./ImageWatermark.vue?vue&type=script&lang=js"
export * from "./ImageWatermark.vue?vue&type=script&lang=js"

import "./ImageWatermark.vue?vue&type=style&index=0&id=49bd2861&scoped=true&lang=css"

import exportComponent from "/Users/emperinter/app/HTML/watermark-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bd2861"]])

export default __exports__